import type { ReactNode } from 'react';

/**
 * Centered layout for Clerk sign-in / sign-up — full viewport, title, subtle branded background.
 */
export default function AuthPageShell({ children }: { children: ReactNode }) {
  return (
    <div className="auth-page-shell">
      <div className="auth-page-shell__glow" aria-hidden />
      <div className="auth-page-shell__inner">
        <header className="auth-page-shell__header">
          <h1 className="auth-page-shell__title">ipSCAPE Wallboard</h1>
          <p className="auth-page-shell__subtitle">
            Live agent status, dashboards, and call history for your contact centre.
          </p>
        </header>
        <div className="auth-page-shell__card-wrap">{children}</div>
      </div>
    </div>
  );
}
